export default function SkillCard({ skill }) {
  return (
    <div className="bg-gradient-to-br from-white to-gray-50 border border-gray-100 rounded-2xl shadow-sm hover:shadow-md transition-all duration-200 p-5 flex flex-col items-start">
      <div className="flex items-center gap-3 mb-3 w-full">
        <div className="w-10 h-10 rounded-lg bg-blue-50 flex items-center justify-center text-blue-600 font-semibold">
          ⚡
        </div>
        <h4 className="font-semibold text-gray-800 text-base leading-snug">
          {skill.name}
        </h4>
      </div>

      <p className="text-sm text-gray-500 flex-grow leading-relaxed">
        {skill.description || "No description available."}
      </p>

      <div className="mt-4 w-full flex justify-end">
   <button
  onClick={() => window.open(skill.link, "_blank")}
  className="px-3 py-1.5 text-xs bg-blue-600 text-white rounded-lg hover:opacity-90 transition"
>
  Learn More
</button>

      </div>
    </div>
  );
}
